import React from "react";
import "./myWork.css";
import {GoArrowRight} from "react-icons/go";

export default function Projects() {
    return (
        <div id="Work"className="myWork">
            <div className="myWorkTitle">
                <h1>My projects</h1>
                <img src="/images/back.png" alt="" />
            </div>
            <div className="myWorkCont">
                <a href="http://ecoscore.ccbp.tech"><img src="/images/eco.png" alt="" /></a>
                <a href="https://github.com/Tobi0203/FinalYearProject"><img src="/images/SocialHub.png" alt="" /></a>
                <a href="https://portzen.vercel.app"><img src="/images/portZen.jpg" alt="" /></a>

                {/* <img src="/images/image5.jpg" alt="" />
                <img src="/images/image3.jpg" alt="" />
                <img src="/images/image4.jpeg" alt="" />
                <img src="/images/image5.jpg" alt="" /> */}
            </div>
            <div className="myWorkShowMore">
                <p>Show more</p>
                <GoArrowRight/>
            </div>
        </div>
    )
}
